module.exports = __webpack_public_path__ + "static/media/2 (10).95064e62.jpg";